import type stylusDynamicState from './state'

export const getFontSizeType = (state: typeof stylusDynamicState) => {
	return state.fontSizeType
}
